import React, {Component} from 'react';
import Table from '../../../components/table/Table';
import {Col, Button, Card, CardBody} from 'reactstrap';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import FontAwesome from 'react-fontawesome';
import * as http from '../../../modules/http';
import {
    eq_open_update_form,
    eq_delete
} from '../../../redux/actions/EquipmentActions';
import * as TextManager from "../../../modules/languages/TextManager";
import * as environment from '../../../modules/environment';
import EditEquipmentForm from  './EditEquipmentForm'
import Modal from "./Modal";



class EquipmentTable extends Component {

    constructor(props) {
        super(props);
        this.state = {
            windowType: 0,
            selectedID: '0',
            saving: false,
            error: false
        };
    }

    editItem = (item) => {
        if (item.id === this.state.selectedID) {
            this.setState({selectedID: 0});
        } else {
            this.props.dispatch(eq_open_update_form(item));
            this.setState({selectedID: item.id});
        }
    };

    addItem = () => {
        this.props.dispatch(eq_open_update_form({
            id: 0,
            groupId: this.props.groupId,
            groupName: this.props.groupName,
            name: "",
            text: "",
            image: null
        }));
        this.setState({
            selectedID: 0, windowType: 2, error: false,
        });
    };

    deleteItem = (offer) => {

        //abc
        http.postToServer(
             'equip/equip_delete?id=' + offer.id,
             {},
             (response) => {
                 this.props.dispatch(eq_delete(offer));

             },
             (response) => {
                 console.log('error delete equip');
             }
        );

    };

    getStatus = (status) => {
        // if (status === 1)
        //     return TextManager.getCurrentTextResource().Utils.active;
        // else
        //     return TextManager.getCurrentTextResource().Utils.inactive;
        return "";
    };

    getStatusColor = (status) => {
        if (status === 1)
            return "success";
        else
            return "danger";
    };

    changeStatus = (index) => {
        // let offer = this.props.data[index];
        // offer.status = offer.status === 1 ? 2 : 1;
        //
        // this.setState({saving: true, error: false});
        //
        // let requestUrl = 'update/offer';
        // http.postToServer(
        //     requestUrl,
        //     offer,
        //     (response) => {
        //
        //         this.setState({saving: false, error: false});
        //         this.props.dispatch(providers_update(response.data));
        //     },
        //     (response) => {
        //         console.warn('error storing', response);
        //         this.setState({saving: false, error: true})
        //
        //     }
        // );
    };

    getRow(provider, index) {

        let logoUrl = environment.getServerBasePath() + '/equip/equip_download?equipID=' + provider.id;
        return (

            <React.Fragment key={provider.id}>

                <tr key={provider.id}>

                    <td>
                        <Modal color='danger' title='Are you sure!'
                               approve={() => this.deleteItem(provider)}
                               message={'Delete item ' + provider.name + '?'}>
                            <Button color='danger' size='sm' onClick={(e) => e.preventDefault()}
                                    style={{padding: "0px 15px"}}>
                                <FontAwesome name='times'/>
                            </Button>

                        </Modal>
                    </td>

                    <td>
                        <Button color='primary' size='sm'
                                style={{padding: "0px 15px"}}
                            onClick={() => this.editItem(provider)}>ערוך</Button>
                    </td>

                    <td>{provider.text}</td>
                    <td>
                        <img src={logoUrl} style={{maxWidth: '200px', objectFit: 'cover' }}/>
                    </td>
                    <td>{provider.name}</td>
                    <td>{provider.serialNumber}</td>


                </tr>

                {provider.id === this.state.selectedID &&
                <tr key={provider.id + 2000}>
                    <td colSpan="7">
                        <EditEquipmentForm  index={index} onClose={() => this.setState({selectedID: 0, windowType: 0})}/>
                    </td>
                </tr>}
            </React.Fragment>
        );
    }

    render() {

        //console.log(this.props.all);

        const rows = this.props.data.map((item, index) =>
            this.getRow(item, index)
        );

        let isAdding = this.state.windowType === 2 && this.state.selectedID === 0;

        return (
            <Col md={12} xl={12} lg={12} xs={12}>
                <Card>
                    <CardBody>
                        {isAdding &&
                            <EditEquipmentForm onClose={() => this.setState({selectedID: 0, windowType: 0})}/>
                        }

                        { !isAdding &&
                        <Table responsive className='table--bordered' dir="rtl">
                            <thead>
                            <tr>

                                <th></th>
                                <th>
                                    <Button color='primary' size='sm'
                                            style={{padding: "0px 15px", margin: "0px"}}
                                            onClick={() => this.addItem()}>
                                        <i className="fas fa-plus" > </i>
                                    </Button>
                                </th>
                                <th>תיאור</th>
                                <th>{TextManager.getCurrentTextResource().Providers.image}</th>
                                <th>שם ציוד</th>
                                <th>מק"ט</th>
                                {/*<th>מספר ציוד</th>*/}

                            </tr>
                            </thead>
                            <tbody>
                            {rows}
                            </tbody>
                        </Table>
                        }
                    </CardBody>
                </Card>
            </Col>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        status: state.equipment.status,
        //data: state.equipment.data.equip,
        userData: state.userData
    };
};

export default withRouter(connect(mapStateToProps)(EquipmentTable))